import React from "react";
import { currencyFormatter } from "../../../../../_metronic/_helpers";
import { Card, CardBody } from "../../../../../_metronic/_partials/controls";

export function GrandTotalWidget({
  grand_total,
}) {

  return (
    <div className="row">
      <div className="col row m-0 p-0">
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Card>
            <CardBody>
              <h4 className="h4">Grand Total Zakat</h4>
              <div className="d-flex justify-content-end">
                <div className="h2 m-5">
                  {currencyFormatter(+grand_total.total_zakat || 0)}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Card>
            <CardBody>
              <h4 className="h4">Grand Total Infaq</h4>
              <div className="d-flex justify-content-end">
                <div className="h2 m-5">
                  {currencyFormatter(+grand_total.total_infaq || 0)}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <Card>
            <CardBody>
              <h4 className="h4">Grand Total Sedekah</h4>
              <div className="d-flex justify-content-end">
                <div className="h2 m-5">
                  {currencyFormatter(+grand_total.total_alms || 0)}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
